import { useMutation } from 'react-query'
import { api } from '../../../api'
import { type ProjectPersistence } from '../../../../types/persistence/project-persistence'

const createProject = async (data: ProjectPersistence) => {
  const asset = data?.assetIds?.map((item) => {
    return Number(item.id)
  })

  const analyst = data?.analystIds?.map((item) => {
    return Number(item.id)
  })

  const dataFormated = { ...data, assetIds: asset, analystIds: analyst }

  const response = await api.post('/projects', dataFormated)
  return response.data
}

export const useProjectCreateMutation = () => {
  return useMutation({
    mutationFn (data: ProjectPersistence) {
      return createProject(data)
    }
  })
}
